/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_TitleInputs */

const en_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seeds & growing`)
};

const th_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมล็ดพันธุ์และการปลูก`)
};

const ja_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seeds & growing`)
};

const fr_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seeds & growing`)
};

const es_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seeds & growing`)
};

const ru_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seeds & growing`)
};

const zh_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seeds & growing`)
};

const vi_chat_title = /** @type {(inputs: Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạt giống và cách trồng`)
};

/**
* | output |
* | --- |
* | "Seeds & growing" |
*
* @param {Chat_TitleInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_title = /** @type {((inputs?: Chat_TitleInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_TitleInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_title(inputs)
	if (locale === "ja") return ja_chat_title(inputs)
	if (locale === "fr") return fr_chat_title(inputs)
	if (locale === "es") return es_chat_title(inputs)
	if (locale === "ru") return ru_chat_title(inputs)
	if (locale === "zh") return zh_chat_title(inputs)
	if (locale === "vi") return vi_chat_title(inputs)
	return en_chat_title(inputs)
});